document.addEventListener(
  "DOMContentLoaded",
  () => {

    const btn =
      document.getElementById(
        "myDesignsBtn"
      );

    const modal =
      document.getElementById(
        "designLibraryModal"
      );

    const list =
      document.getElementById(
        "savedDesignList"
      );

    const closeBtn =
      document.getElementById(
        "closeDesignLibrary"
      );

    if(!btn) return;

    btn.addEventListener(
      "click",
      async () => {

        const { data,error } =
          await window.embroiderySupabase
            .from("embroidery_designs")
            .select("*")
            .order(
              "created_at",
              {
                ascending:false
              }
            );
            console.log(
  "MY DESIGNS DATA:",
  data
);

        if(error){

          console.error(error);

          return;

        }

        list.innerHTML = "";

        data.forEach(design => {

          const card =
            document.createElement("div");

          card.className =
            "saved-design-card";

            console.log(
  "CARD NAME:",
  design.design_name
);
            card.innerHTML = `
<strong>
${design.design_name || "Untitled Design"}
</strong>
<br>
Saved:
${new Date(
  design.created_at
).toLocaleDateString()}
`;
          card.addEventListener(
  "click",
  () => {

    console.log(
      "LOADING DESIGN",
      design
    );

    window.EMBStorage.loadDesign(
      design.design_data
    );

    modal.style.display =
      "none";

  }
);

          list.appendChild(card);

        });

        modal.style.display =
          "block";

      }
    );

    closeBtn?.addEventListener(
      "click",
      () => {

        modal.style.display =
          "none";

      }
    );

  }
);